import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * DevTools component provides a floating button for developers to toggle
 * the pseudo-language (en-XA) and test layout robustness.
 * Only rendered in development mode.
 */
export const DevTools: React.FC = () => {
  const { i18n } = useTranslation();

  if (import.meta.env.PROD) {
    return null;
  }

  const togglePseudo = () => {
    const currentLang = i18n.language;
    const newLang = currentLang === 'en-XA' ? 'en' : 'en-XA';
    void i18n.changeLanguage(newLang);
  };

  return (
    <div className="fixed bottom-4 left-4 z-[9999] flex gap-2">
      <button
        onClick={togglePseudo}
        className="px-3 py-1 bg-black/80 text-white text-[10px] font-mono rounded-full border border-white/20 hover:bg-black transition-colors shadow-lg"
        title="Toggle Pseudo-Language (en-XA)"
      >
        {i18n.language === 'en-XA' ? 'DISABLE PSEUDO' : 'ENABLE PSEUDO'}
      </button>
    </div>
  );
};
